/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Impressum_Ust_PendingInputs */

const en_impressum_ust_pending = /** @type {(inputs: Impressum_Ust_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Small business pursuant to Section 19 UStG (Kleinunternehmerregelung). No VAT is charged. A VAT identification number (USt-IdNr.) is not required under this regime.`)
};

const de_impressum_ust_pending = /** @type {(inputs: Impressum_Ust_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kleinunternehmer gemaess SS 19 UStG (Kleinunternehmerregelung). Es wird keine Umsatzsteuer ausgewiesen. Eine Umsatzsteuer-Identifikationsnummer (USt-IdNr.) ist unter dieser Regelung nicht erforderlich.`)
};

const fr_impressum_ust_pending = /** @type {(inputs: Impressum_Ust_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Micro-entreprise conformément au § 19 UStG (Kleinunternehmerregelung). Aucune TVA n'est facturée. Un numéro d'identification TVA (USt-IdNr.) n'est pas requis dans ce régime.`)
};

const es_impressum_ust_pending = /** @type {(inputs: Impressum_Ust_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Microempresa conforme al artículo 19 UStG (Kleinunternehmerregelung). No se cobra IVA. No se requiere un número de identificación fiscal (USt-IdNr.) bajo este régimen.`)
};

const it_impressum_ust_pending = /** @type {(inputs: Impressum_Ust_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Piccola impresa ai sensi del §19 UStG (regime dei piccoli imprenditori). Non viene addebitata l'IVA. Un numero di identificazione IVA (USt-IdNr.) non è richiesto in questo regime.`)
};

const nl_impressum_ust_pending = /** @type {(inputs: Impressum_Ust_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kleinondernemer conform § 19 UStG (Kleinunternehmerregelung). Er wordt geen btw in rekening gebracht. Een btw-identificatienummer (USt-IdNr.) is niet vereist onder deze regeling.`)
};

const pl_impressum_ust_pending = /** @type {(inputs: Impressum_Ust_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Małe przedsiębiorstwo na podstawie § 19 UStG (Kleinunternehmerregelung). VAT nie jest naliczany. Numer identyfikacji podatkowej VAT (USt-IdNr.) nie jest wymagany w ramach tego reżimu.`)
};

const fi_impressum_ust_pending = /** @type {(inputs: Impressum_Ust_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pienyrittäjä UStG:n 19 §:n (Kleinunternehmerregelung) mukaisesti. ALV:a ei peritä. ALV-tunnistetta (USt-IdNr.) ei edellytetä tässä järjestelmässä.`)
};

const da_impressum_ust_pending = /** @type {(inputs: Impressum_Ust_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Småvirksomhed i henhold til § 19 UStG (Kleinunternehmerregelung). Der opkræves ingen moms. Et momsregistreringsnummer (USt-IdNr.) er ikke påkrævet under denne ordning.`)
};

const sv_impressum_ust_pending = /** @type {(inputs: Impressum_Ust_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Småföretagare enligt 19 UStG (Kleinunternehmerregelung). Ingen moms debiteras. Ett momsregistreringsnummer (USt-IdNr.) krävs inte under detta system.`)
};

/**
* | output |
* | --- |
* | "Small business pursuant to Section 19 UStG (Kleinunternehmerregelung). No VAT is charged. A VAT identification number (USt-IdNr.) is not required under this ..." |
*
* @param {Impressum_Ust_PendingInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const impressum_ust_pending = /** @type {((inputs?: Impressum_Ust_PendingInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Impressum_Ust_PendingInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_impressum_ust_pending(inputs)
	if (locale === "fr") return fr_impressum_ust_pending(inputs)
	if (locale === "es") return es_impressum_ust_pending(inputs)
	if (locale === "it") return it_impressum_ust_pending(inputs)
	if (locale === "nl") return nl_impressum_ust_pending(inputs)
	if (locale === "pl") return pl_impressum_ust_pending(inputs)
	if (locale === "fi") return fi_impressum_ust_pending(inputs)
	if (locale === "da") return da_impressum_ust_pending(inputs)
	if (locale === "sv") return sv_impressum_ust_pending(inputs)
	return en_impressum_ust_pending(inputs)
});